import { render, staticRenderFns } from "./urgentorder-add.vue?vue&type=template&id=a0fa78aa&"
import script from "./urgentorder-add.vue?vue&type=script&lang=ts&"
export * from "./urgentorder-add.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports